import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createBasket, updateBasket } from '@store/basket/actions';

import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { changeJourneyParam } from '@store/yourJourney/actions';

import { TablesContainerV2 } from './TablesContainerV2';

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createBasket,
      updateBasket,
      changeJourneyParam,
    },
    dispatch
  );

const mapStateToProps = (state) => {
  return {
    property: entitySelectors.getProperty(state),
    journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
    basketDetails: basketSelectors.getBasketDetails(state),
    tablesPage: entitySelectors.getTablesPage(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TablesContainerV2 as any) as any;
